module.exports = __webpack_public_path__ + "img/step1.7db6da74.svg";